import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import professionalInformationFormMeta, { IProfessionalInformationFormMeta } from "./professionalInformationFormMeta";

export interface IApplicantFormMeta extends IProfessionalInformationFormMeta {
  title: FormInputMeta;
  lastName: FormInputMeta;
  firstName2: FormInputMeta;
  firstName: FormInputMeta;
  birthDate: FormInputMeta;
  birthPlace: FormInputMeta;
  firstIdentityType: FormInputMeta;
  identity1: FormInputMeta;
  secondIdentityType: FormInputMeta;
  identity2: FormInputMeta;
  sex: FormInputMeta;
  familyStatus: FormInputMeta;
  nationality: FormInputMeta;
  numberDependents: FormInputMeta;

  schema: any;
}

let applicantFormMeta = {} as IApplicantFormMeta;

applicantFormMeta.title = {
  name: "title",
  type: "select",
  label: "Titre",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.lastName = {
  name: "lastName",
  type: "text",
  label: "Prénom",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !"),
};

applicantFormMeta.firstName2 = {
  name: "firstName2",
  type: "text",
  label: "Nom 2",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.firstName = {
  name: "firstName",
  type: "text",
  label: "Nom",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !"),
};

applicantFormMeta.birthDate = {
  name: "birthDate",
  type: "date",
  label: "Date Naiss.",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.birthPlace = {
  name: "birthPlace",
  type: "text",
  label: "Lieu Naissance",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.firstIdentityType = {
  name: "firstIdentityType",
  type: "select",
  label: "Type Prem. Identité",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.identity1 = {
  name: "identity1",
  type: "text",
  label: "Identité",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.secondIdentityType = {
  name: "secondIdentityType",
  type: "select",
  label: "Type Deuxième Identité",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.identity2 = {
  name: "identity2",
  type: "text",
  label: "Identité",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.sex = {
  name: "sex",
  type: "select",
  label: "Sexe",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.familyStatus = {
  name: "familyStatus",
  type: "select",
  label: "Situa. Famil.",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.nationality = {
  name: "nationality",
  type: "select",
  label: "Nationalité",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta.numberDependents = {
  name: "numberDependents",
  type: "text",
  label: "Nbre. Dépendants",
  placeholder: "",
  validation: yup.string(),
};

applicantFormMeta = { ...applicantFormMeta, ...professionalInformationFormMeta }

applicantFormMeta.schema = yup.object().shape(getValidationSchema(applicantFormMeta));

export default applicantFormMeta;